import { CHART_COLOURS as COLORS } from '../../common/constants';

export const transformSegments = (segmentsState) => {
    if (segmentsState && segmentsState.length) {
        return segmentsState.map((segment) => {
            return {
                id: segment.id,
                title: segment.name,
            };
        });
    } else {
        return [];
    }
};

export const transformTags = (topTags, colourCode) => {
    if (topTags && topTags.length) {
        return topTags.map((topTag, index) => {
            return {
                tag: topTag.tag,
                count: parseInt(topTag.total),
                color:
                    colourCode == 'orange'
                        ? COLORS.ORANGE[index % COLORS.ORANGE.length]
                        : COLORS.BLUE[index % COLORS.BLUE.length],
            };
        });
    } else {
        return [];
    }
};
